import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import Header from "../../components/Header";
import { BreadcrumbBox } from "../../components/common/Breadcrumb";
import Footer from "../../components/Footer";
import { Styles } from "./styles/eventDetails.js";
import axios from "axios";
import { Constant, imageDomain } from "../../helper/Constants.js";
import PopularCourse from "../courses/components/PopularCourse.js";

class EventDetails extends Component {
  state = {
    event: null,
    loading: true,
    error: null,
  };

  componentDidMount() {
    const eventId = window.location.pathname.split("/")[2];
    this.fetchEventDetails(eventId);
  }

  // Convert backend date into readable format
  formatReadableDate = (dateStr = "") => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return "";
    const day = d.getDate();
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return `${day} ${monthNames[d.getMonth()]} ${d.getFullYear()}`;
  };

  fetchEventDetails = async (eventId) => {
    this.setState({ loading: true, error: null });

    try {
      const baseUrl =
        (Constant && Constant.getUrls && Constant.getUrls.getAllEvents) ||
        "/event";

      const resp = await axios.get(`${baseUrl}/${eventId}`);
      const payload = resp?.data?.data;

      this.setState({
        event: payload,
        loading: false,
      });
    } catch (err) {
      this.setState({
        event: null,
        loading: false,
        error: "Failed to load event details",
      });
    }
  };

  getImageUrl = (imgPath) => {
    if (!imgPath)
      return process.env.PUBLIC_URL + "/assets/images/default-event.jpg";
    if (/^https?:\/\//i.test(imgPath)) return imgPath;

    return imageDomain.replace(/\/+$/, "") + "/" + imgPath.replace(/^\/+/, "");
  };

  render() {
    const { event, loading, error } = this.state;

    return (
      <Styles>
        <div className="main-wrapper event-details-page">
          <Header />
          <BreadcrumbBox title="Event Details" />

          <section className="event-details-area">
            <Container>
              <Row>
                <Col lg="9" md="8" sm="12">
                  {loading ? (
                    <p>Loading...</p>
                  ) : error ? (
                    <p style={{ color: "red" }}>{error}</p>
                  ) : !event ? (
                    <p>Event not found.</p>
                  ) : (
                    <div className="event-details-content">
                      {/* Event Heading */}
                      <div className="heading">
                        <h4>{event.name}</h4>
                      </div>

                      {/* Event Info Row */}
                      <div className="event-icon">
                        <ul className="list-unstyled list-inline">
                          <li className="list-inline-item">
                            <i className="las la-calendar"></i>{" "}
                            {this.formatReadableDate(event.event_date)}
                          </li>
                          {event.event_type && (
                            <li className="list-inline-item">
                              <i className="las la-clock"></i>{" "}
                              {event.event_type}
                            </li>
                          )}
                          {event.event_venue && (
                            <li className="list-inline-item">
                              <i className="las la-map-marker"></i>{" "}
                              {event.event_venue}
                            </li>
                          )}
                          <li className="list-inline-item">
                            <i className="las la-bullhorn"></i>{" "}
                            {event.event_status}
                          </li>
                        </ul>
                      </div>

                      {/* Banner Image */}
                      <div className="event-details-banner">
                        <img
                          src={this.getImageUrl(event.image)}
                          alt="Event Banner"
                          className="img-fluid"
                        />
                      </div>

                      {/* Event Overview */}
                      <div className="event-details-overview">
                        <h5>Event Overview</h5>
                        <div
                          className="event-html"
                          dangerouslySetInnerHTML={{
                            __html: event.event_details || "",
                          }}
                        />
                      </div>
                    </div>
                  )}
                </Col>

                {/* Sidebar - NOW Dynamic */}
                <Col lg="3" md="4" sm="12">
                  {event && (
                    <div className="event-details-sidebar">
                      <div className="event-sidebar-info">
                        <ul className="list-unstyled event-info-list">
                          <li>
                            Date:{" "}
                            <span>
                              {this.formatReadableDate(event.event_date)}
                            </span>
                          </li>
                          <li>
                            Type: <span>{event.event_type}</span>
                          </li>
                          <li>
                            Status: <span>{event.event_status}</span>
                          </li>
                          <li>
                            Venue: <span>{event.event_venue}</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  )}
                  <PopularCourse />
                </Col>
              </Row>
            </Container>
          </section>

          <Footer />
        </div>
      </Styles>
    );
  }
}

export default EventDetails;
